import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import React from 'react'
import { render } from 'react-dom';
import { HashRouter } from 'react-router-dom';
import App from './App'

render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById('root')
);

